export enum Theme {
  Unknown = 0,
  WaveDark = 1,
  WaveLight = 2,
  Dark = 3,
  Light = 4
}
